import Player from "../sports/common/player";
import { isDefined, isString, pick } from "../services/common/object-util";
import { fromCode } from "../sports/football/enums/player-position";

const allowedPlayerDataProperties = [
    "throws",
    "height",
    "bats",
    "weight",
    "hometown",
    "rank",
    "accepted",
    "full_name",
    "nickname",
    "first_name",
    "last_name",
    "title",
    "organization",
    "city",
    "state",
    "zipcode",
    "country",
    "phone1",
    "phone2",
    "email_address",
    "born",
    "bat_throws",
    "year",
    "hometown",
    "highschool",
    "college",
    "position",
    "position_abbr",
    "events",
    "weight_class",
    "draft",
    "number",
    "major",
    "team",
    "home_address",
    "highschool_athletic",
    "highschool_academic",
    "prev_sports",
    "prev_college_athletic",
    "prev_college_academic",
    "mother_name",
    "father_name",
    "brother_name",
    "sister_name",
    "minor",
    "custom1",
    "custom2",
    "custom3",
    "custom4",
    "custom5",
    "custom6",
    "custom7",
    "custom8",
    "custom9",
    "custom10",
    "national_ranking",
    "regional_ranking",
    "conference_ranking",
    "starter"
];

const mapPlayer = (jsonObj, teamId) => {
    const player = Object.assign(new Player(), jsonObj);
    const playerPositions = isString(player.position)
        ? player.position.split("/")
        : [];
    const { national_ranking, regional_ranking, conference_ranking, starter } =
        player.data || {};
    player.positions = playerPositions.map(fromCode);
    player.teamId = teamId;
    player.nationalRanking = national_ranking;
    player.regionalRanking = regional_ranking;
    player.conferenceRanking = conference_ranking;
    player.starter = isDefined(starter) ? Boolean(starter === "true") : true;

    return player;
};

const mapPlayerDto = (player) => {
    const {
        uniform,
        positions,
        playerId,
        firstName,
        lastName,
        year,
        nationalRanking,
        regionalRanking,
        conferenceRanking,
        starter
    } = player;
    const { _type, ...data } = player.data || {};
    const dto = {
        playerId,
        firstName,
        lastName,
        position: positions?.map((p) => p?.code).join("/"),
        number: uniform || uniform === 0 ? uniform : "",
        year: year,
        data: {
            ...pick(data, allowedPlayerDataProperties),
            national_ranking: nationalRanking,
            regional_ranking: regionalRanking,
            conference_ranking: conferenceRanking,
            starter
        }
    };

    return dto;
};

export { mapPlayer, mapPlayerDto };
